import request from '@/utils/request'

// 分页查询应用场景信息列表
export function pageApplicationScene(query) {
  return request({
    url: '/website/applicationScene/page',
    method: 'get',
    params: query
  })
}